import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Popper, Grid, Typography, Box } from "@material-ui/core";
import classNames from "classnames";
import InfoIcon from "@material-ui/icons/InfoOutlined";

const DEFAULT_TOOLTIP_TITLE = `*Get these rates with ${process.env.REACT_APP_MOLLIES_MEMBER_TITLE}`;

const DEFAULT_TOOLTIP_DESCRIPTION =
  "Our best prices are reserved for members. Select a member rate while booking your room, and you'll be guided to sign in or sign up to access the discount at checkout.";

const useStyles = makeStyles((theme) => ({
  memberRateContainer: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    display: "flex",
    gap: "8px",
    alignItems: "center",
    padding: "2px 8px",
    borderRadius: "4px",
  },
  memberRateInfo: {
    background: theme.palette.info.main,
    color: theme.palette.info.contrastText,
    padding: "1.25rem",
    maxWidth: "80vw",
  },
  memberRateInfoContainer: {
    zIndex: 100000,
  },
  infoIcon: {
    color: theme.palette.secondary.contrastText,
    fontSize: "1.3rem",
    marginLeft: "10px",
    cursor: "pointer",
  },
}));

const MemberTag = ({
  onClick,
  className = "",
  label,
  showTooltip = false,
  tooltipTitle,
  tagVariant = "subtitle1",
  tooltipDescription,
  ...otherProps
}) => {
  const classes = useStyles();
  const [memberRateInfoAnchor, setMemberRateInfoAnchor] = React.useState(null);
  const open = Boolean(memberRateInfoAnchor);

  const handlePopperOpen = (event) => {
    if (showTooltip) {
      setMemberRateInfoAnchor(event.currentTarget);
    }
  };

  const handlePopperClose = () => {
    setMemberRateInfoAnchor(null);
  };

  return (
    <Box className={classNames(classes.memberRateContainer, className)}>
      <Typography variant={tagVariant} {...otherProps}>
        {label || "Member"}
      </Typography>
      {showTooltip && (
        <InfoIcon
          className={classes.infoIcon}
          onMouseEnter={handlePopperOpen}
          onMouseLeave={handlePopperClose}
        />
      )}
      {showTooltip && (
        <Popper
          id="member-rate-info"
          open={open}
          anchorEl={memberRateInfoAnchor}
          className={classes.memberRateInfoContainer}>
          <Grid className={classes.memberRateInfo} item>
            <Typography variant="subtitle1" style={{ marginBottom: "8px" }}>
              {tooltipTitle || DEFAULT_TOOLTIP_TITLE}
            </Typography>
            <Typography variant="body2">
              {tooltipDescription || DEFAULT_TOOLTIP_DESCRIPTION}
            </Typography>
          </Grid>
        </Popper>
      )}
    </Box>
  );
};

MemberTag.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  label: PropTypes.string,
  showTooltip: PropTypes.bool,
  tooltipTitle: PropTypes.string,
  tooltipDescription: PropTypes.string,
  tagVariant: PropTypes.string,
};

export default MemberTag;
